// カノニカルURLの最初のパラメータに対応
export const FIRST_CANONICAL_PARAM_REGEX = /\/j_[^/]+__/;
// カノニカルURLの２番目以降のパラメータに対応
export const SUBSEQUENT_CANONICAL_PARAM_REGEX = /\/-([^/?]+__[^/?]+)/;
// 両方のパラメータに対応
export const CANONICAL_PARAM_REGEX = /(\/j_|\/-)[^/]*__[^/]+\//;
